import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import PaidIcon from "@mui/icons-material/Paid";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InsightsIcon from "@mui/icons-material/Insights";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import AssessmentIcon from "@mui/icons-material/Assessment";
import GavelIcon from "@mui/icons-material/Gavel";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const CATEGORY_ICONS = {
    "Fleet Utilization Trends": FlightTakeoffIcon,
    "Revenue & Cashflow Performance": PaidIcon,
    "Lease Expiry": EventBusyIcon,
    "Insurance Expiry": VerifiedUserIcon,
    "Upcoming Escalation Events": EventRepeatIcon,
    "Active Alerts": WarningAmberIcon,
    "Maintenance Exposure": PrecisionManufacturingIcon,
    "Utilization Tracking": DonutLargeIcon,
    "Lessee Risk & Performance": AssessmentIcon,
    "Compliance & Contractual Obligations": GavelIcon,
    "Lease Options Pipeline": AltRouteIcon,
    "Portfolio, Credit and Operational Intelligence": AccountBalanceIcon,
    "Invoice Generation Calendar": ReceiptLongIcon,
};

export function getCategoryIcon(title) {
    return CATEGORY_ICONS[title] || InsightsIcon;
}
